<template>
  <v-container>
    <v-row>
      <v-combobox
        class="mx-4"
        v-model="stags"
        :items="campaign.Tags"
        :search-input.sync="search"
        hide-selected
        label="Search some tags"
        multiple
        small-chips
        outlined
      ></v-combobox>
      <NewNote />
    </v-row>
    <v-row justify="center">
      <v-hover v-for="note in filteredNotes" :key="note.id">
        <template v-slot:default="{ hover }">
          <v-card max-width="350" class="ma-4">
            <v-card-subtitle class="primary--text">{{note.Note | Trim}}</v-card-subtitle>
            <v-card-text>
              <v-chip class="pa-2 mr-1 mb-1" small v-for="tag in note.tags" :key="tag">{{tag}}</v-chip>
            </v-card-text>

            <v-fade-transition>
              <v-overlay v-if="hover" absolute color="#036358">
                <v-btn
                  class="primary"
                  :to="{ name: 'EditNote', params: { id: note.id } }"
                >See more info</v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </template>
      </v-hover>
    </v-row>
  </v-container>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";
import { store } from "@/fb";

import NewNote from "@/components/NewNote";

export default {
  components: { NewNote },
  data: () => ({
    search: "",
    notes: [],
    stags: null,
    campaign: {},
  }),
  computed: {
    filteredNotes: function () {
      return this.notes.filter((note) => {
        if (this.stags == null || this.stags.length == 0) {
          return true;
        }
        let matchingTags = 0;
        for (var i = 0; i < this.stags.length; i++) {
          if (note.tags.includes(this.stags[i])) {
            matchingTags++;
          }
          if (matchingTags == this.stags.length) {
            return true;
          }
        }

        return false;
      });
    },
  },
  filters: {
    Trim: function (value) {
      if (!value) return "";
      if (value.length >= 50) return value.substring(0, 50) + "...";
      return value;
    },
  },
  firestore() {
    return {
      notes: db
        .collection("notes")
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
        .where("CampaignId", "==", store.CurrentCampaign.id),
      campaign: db.collection("campaigns").doc(store.CurrentCampaign.id),
    };
  },
  created() {},
};
</script>